import * as MuiIcons from '@mui/icons-material';
import TikTokIcon from './TikTokIcon';
import WeChatIcon from './WeChatIcon';

const Icons = {
  ...MuiIcons,
  TikTok: TikTokIcon,
  WeChat: WeChatIcon,
};

export default Icons;
